import gql from "graphql-tag";

const flexEntityFieldsFragment = gql`
	fragment FlexEntityFields on FlexEntity {
		id
		uuid
		tenantId
		createdOn
		createdByName
		lastUpdatedOn
		status
		occurrence
		patientId
		preparationBrandNames
		preparationGenericNames
		quantity
		isArchived
		isDeleted
		data
		containerType
	}
`;

export const GET_PATIENTS_BY_INSURANCE_ID = gql`
	${flexEntityFieldsFragment}

	query GetPatientsByInsuranceId($idPrefix: String!, $formTypeId: String!) {
		patients(
			where: { insuranceId_CONTAINS: $idPrefix, assignedFlexEntities_SOME: { type: { isStartingPoint: true }, isDeleted: false } }
			options: { limit: 10 }
		) {
			id
			insuranceId
			assignedFlexEntities(where: { status: SUBMITTED, isDeleted: false }) {
				...FlexEntityFields
				cases(where: { isDeleted: false, baseAgreement: { allowedForms_INCLUDES: $formTypeId } }) {
					id
					baseAgreement {
						requiredForms
						allowedForms
					}
					flexEntities(where: { isDeleted: false }) {
						...FlexEntityFields
					}
				}
			}
		}
	}
`;

export const GET_CASES_BY_INSURANCE_ID = gql`
	query SearchCasesByPatientInsuranceId($insuranceId: String!, $formTypeId: String!) {
		cases(where: { isDeleted: false, patient: { insuranceId: $insuranceId }, baseAgreement: { allowedForms_INCLUDES: $formTypeId } }) {
			id
			suspensionReason
			sourceTenantId
			isArchived
			isTreatmentDiscontinued
			documentStatus
			actualAgreementId
			flexEntitiesConnection(where: { node: { isDeleted: false, type: { isStartingPoint: true } } }) {
				edges {
					isStartingPoint
					node {
						id
						type {
							id
						}
					}
				}
			}
			preparationBrandName
			preparations {
				BrandName
				DescriptionDe
			}
		}
	}
`;

export const GET_PATIENTS_BY_INSURANCE_ID_PREFIX = gql`
	query SearchPatientsById($idPrefix: String!) {
		patients(where: { insuranceId_MATCHES: $idPrefix, assignedFlexEntities_SOME: { isDeleted: false } }, options: { limit: 10 }) {
			insuranceId
		}
	}
`;

export const GET_POSSIBLE_STARTING_POINT_ENTITY_TYPES = gql`
	query GetPossibleStartingPointEntityTypes($formTypeId: String!) {
		flexEntityTypes {
			id
			isStartingPoint
			containerType
			localizationKey
			name
			data
		}

		baseAgreements(where: { isDeleted: false, isHidden: false, allowedForms_INCLUDES: $formTypeId }) {
			allowedForms
		}
	}
`;

export const DELETE_FLEX_ENTITY = gql`
	mutation DeleteFlexEntity($id: ID!) {
		DeleteFlexEntity(id: $id)
	}
`;
